(function() {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivitiesTopActions', directiveFunc);

    function directiveFunc() {
        return {
            restrict: 'E',
            scope: {
                test: '='
            },
            controller: directiveFuncCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/activities/list-panel/activities-top-actions'
        };
    }

    function directiveFuncCtrl(ActivitiesService, ActionManager) {
        var vm = this;
        this.$onInit = function() {
            vm.onSelectTemplate = onSelectTemplate;

            init();
        }

        function init() {
            ActivitiesService.sync(vm);
        }

        function onSelectTemplate(description, title) {
            ActivitiesService.setModel(vm.pageData.options.templateOptions.targetModel.description, description);
            ActivitiesService.setModel(vm.pageData.options.templateOptions.targetModel.title, title);
        }
    }
})();